var map = {
	"./airdrop.vue": 87406,
	"./check.vue": 42591,
	"./face.vue": 8933,
	"./facescan.vue": 27778,
	"./frends.vue": 15143,
	"./home.vue": 95927,
	"./index.vue": 91590,
	"./learderboard.vue": 53587,
	"./ris.vue": 49074,
	"./sign.vue": 15512,
	"./tasks.vue": 95169
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68239;